import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Field, FieldArray, reduxForm } from 'redux-form'
import { TextField, SingleFilePickerField, SelectField } from '../../components'
import { Button } from '../../elements'
import './index.scss'

import validate from './validate'

class ReaderForm extends Component {
    static propTypes = {
        onSubmit: PropTypes.func,
    }
    state = {
        selectedClient: ""
    }

    changeSiteHandler = (values) => {
        this.setState({ selectedClient: values })
    }

    renderReaders({ fields, clientIds, siteIds, agentIds, changeSiteHandler, isSubmiting }) {
        return (
            <div>
                <Button type="primary" onClick={() => fields.push({})}>Add Reader</Button>
                {
                    fields.map((reader, index) =>
                        <div className="form-inline" key={index}>
                            <h4>Reader #{index + 1}</h4>
                            <div className="reader-field">
                                <Field
                                    name="clientId"
                                    label="Client Id"
                                    options={clientIds}
                                    disabled={isSubmiting}
                                    component={SelectField}
                                    onChange={changeSiteHandler}
                                />
                            </div>
                            <div className="reader-field">
                                <Field
                                    name={`${reader}.siteId`}
                                    label="Site Id"
                                    options={siteIds}
                                    disabled={isSubmiting}
                                    component={SelectField}
                                />
                            </div>
                            <div className="reader-field">
                                <Field
                                    name={`${reader}.readerSn`}
                                    label="Reader SN"
                                    disabled={isSubmiting}
                                    component={TextField}
                                />
                            </div>
                            <div className="reader-field">
                                <Field
                                    name={`${reader}.agentId`}
                                    label="Agent Id"
                                    options={agentIds}
                                    disabled={isSubmiting}
                                    component={SelectField}
                                />
                            </div>
                            <div className="reader-field">
                                <Field
                                    name={`${reader}.endpoint`}
                                    label="Endpoint"
                                    disabled={isSubmiting}
                                    component={TextField}
                                />
                            </div>
                            <div className="remove-button">
                                <Button
                                    onClick={() => fields.remove(index)} >X</Button>
                            </div>
                        </div >
                    )
                }
            </div>
        )
    }

    render() {
        const { isSubmiting, handleSubmit, onSubmit, clients, sites, agents } = this.props
        let clientIds = clients.map(client => client.clientId);
        let selectedSiteIds = sites.filter(site => site.clientId == this.state.selectedClient);
        let siteIds = selectedSiteIds.map(site => site.siteId)
        let selectedAgentIds = agents.filter(agent => agent.clientId == this.state.selectedClient);
        let agentIds = selectedAgentIds.map(agent => agent.agentId)
        return (
            <form onSubmit={handleSubmit(onSubmit)}>
                <FieldArray name="readers" component={this.renderReaders} clientIds={clientIds}
                    siteIds={siteIds} agentIds={agentIds} changeSiteHandler={this.changeSiteHandler}
                    isSubmiting={isSubmiting} />
                <Button loading={isSubmiting} htmlType="submit" type="primary">Save All</Button>
            </form>
        )
    }
}

export default reduxForm({
    form: 'reader-form',
    validate,
})(ReaderForm)



// WEBPACK FOOTER //
// ./src/smart-components/reader-form/index.js